module.exports = __webpack_public_path__ + "static/img/_3.f0607f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_3.png
// module id = WdtV
// module chunks = 1